/**
 * Geheimnisse und Zahlungsdaten aus Texten entfernen, die in Protokollen, Fehlerberichten, Antworten oder der Datenbank landen
 * (Anwalt Zusatz 10 und 21, 0181). Dieselben Muster wie app.client_error_clean der Datenbank: Bearer-Kopfzeilen, Parameter mit
 * Schlüsseln (auch im Anker, z. B. #access_token=…), Supabase-JWTs, Stripe- (sk_/rk_/whsec_), Supabase- (sb_secret_), Meta- (EAA…)
 * und Instagram-Schlüssel (IG…), vollständige IBAN und Kartennummern in Vierergruppen. Läuft im Browser, in Deno und in Node.
 */
const PARAM = /\b(access_token|refresh_token|id_token|provider_token|provider_refresh_token|token|code|password|passwort|secret|client_secret|api_key|apikey|key|signature)=([^&\s#"']+)/gi;

export function maskSecrets(text: unknown, mask = "[entfernt]"): string {
  return String(text ?? "")
    .replace(PARAM, (_, k: string) => `${k}=${mask}`)
    .replace(/\bBearer\s+[A-Za-z0-9._~+/=|-]{6,}/gi, `Bearer ${mask}`)
    .replace(/eyJ[A-Za-z0-9_-]{8,}(?:\.[A-Za-z0-9_-]+){0,2}/g, mask)
    .replace(/\b(?:sk|rk)_(?:live|test)_[A-Za-z0-9]{6,}/g, mask)
    .replace(/\bwhsec_[A-Za-z0-9]{6,}/g, mask)
    .replace(/\bsb_secret_[A-Za-z0-9_-]{6,}/g, mask)
    .replace(/\b(?:EAA[A-Za-z0-9]{20,}|IG[A-Za-z0-9_-]{20,})/g, mask)
    .replace(/\b[A-Z]{2}\d{2}(?: ?[A-Z0-9]{4}){2,7}(?: ?[A-Z0-9]{1,4})?\b/g, "[IBAN]")
    .replace(/\b\d{4}(?:[ -]\d{4}){2,3}(?:[ -]\d{1,4})?\b/g, "[Zahl]");
}
